import { render, staticRenderFns } from "./Periodicity.vue?vue&type=template&id=88d6993a"
import script from "./Periodicity.vue?vue&type=script&lang=js"
export * from "./Periodicity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports